import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';

/**
 * Favorite/Bookmark Button Component
 * Allows users to save venues to their favorites
 * Stores favorites in localStorage for persistence
 */
const FavoriteButton = ({ venueId, venueName, onToggle, size = 'default' }) => {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    // Check if venue is in favorites
    const favorites = JSON.parse(localStorage.getItem('ablefam_favorites') || '[]');
    setIsFavorite(favorites.some(fav => fav.id === venueId));
  }, [venueId]);

  const toggleFavorite = (e) => {
    e.stopPropagation(); // Prevent card click
    
    const favorites = JSON.parse(localStorage.getItem('ablefam_favorites') || '[]');
    
    if (isFavorite) {
      // Remove from favorites
      const updated = favorites.filter(fav => fav.id !== venueId);
      localStorage.setItem('ablefam_favorites', JSON.stringify(updated));
      setIsFavorite(false);
    } else {
      // Add to favorites
      const newFavorite = {
        id: venueId,
        name: venueName,
        savedAt: new Date().toISOString()
      };
      favorites.push(newFavorite);
      localStorage.setItem('ablefam_favorites', JSON.stringify(favorites));
      setIsFavorite(true);
    }
    
    if (onToggle) {
      onToggle(!isFavorite);
    }
  };

  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    large: 'w-12 h-12'
  };

  const iconSizes = {
    small: 16,
    default: 20,
    large: 24
  };

  return (
    <button
      onClick={toggleFavorite}
      className={`${sizeClasses[size]} flex items-center justify-center rounded-full transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:ring-offset-2 ${
        isFavorite 
          ? 'bg-pink-100 text-pink-600 hover:bg-pink-200' 
          : 'bg-gray-100 text-gray-400 hover:bg-gray-200 hover:text-pink-500'
      }`}
      aria-label={isFavorite ? `Remove ${venueName} from favorites` : `Add ${venueName} to favorites`}
      aria-pressed={isFavorite}
      title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Heart 
        size={iconSizes[size]} 
        className={isFavorite ? 'fill-current' : ''} 
      />
    </button>
  );
};

export default FavoriteButton;
